'use client';

import { useCartStore } from '@/entities/cart/model/use-cart-store';
import { useNavigationState } from '@/shared/store/use-navigation-state';
import ConfirmModal from '@/widgets/confirm-modal';
import UniversalHeader from '@/widgets/header';
import TrashIcon from '@/widgets/map/Delivery/icons/TrashRed';
import { IconButton } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

const CartHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations();
  const { redirectTo } = useNavigationState();

  const CLEAR = useCartStore((state) => state.CLEAR);

  const handleClear = () => {
    CLEAR();
    setIsOpen(false);
  };
  return (
    <>
      <UniversalHeader
        isBackIcon
        title={t('cart')}
        backLink={redirectTo ? redirectTo : '/'}
        icon={
          <IconButton
            aria-label="Search"
            variant="ghost"
            rounded="xl"
            onClick={() => setIsOpen(true)}
          >
            <TrashIcon color="var(--text-default)" />
          </IconButton>
        }
      />
      <ConfirmModal
        title={t('clear_cart')}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleClear}
      />
    </>
  );
};

export default CartHeader;
